// Runtime-only auth flags — never restore from persisted form_data or Next enables
// before the GQL confirmation query resolves (loading-window race, FCT-53537).
// Kept in its own file so Marketplace consumers can import without pulling in i18n.
export const DATEV_EPHEMERAL_KEY_PATTERNS = [/^authenticated_legal_entity_\d+$/]
